export default {
    headers: {
        activeOrganizationMemberships: {
            id: 'organizationAdmin.headers.activeOrganizationMemberships'
        },
        invitationOrganizationMemberships: {
            id: 'organizationAdmin.headers.invitationOrganizationMemberships'
        },
        pendingOrganizationMemberships: {
            id: 'organizationAdmin.headers.pendingOrganizationMemberships'
        },
        approveMembership: {
            id: 'organizationAdmin.headers.approveMembership'
        },
        rejectMembership: {
            id: 'organizationAdmin.headers.rejectMembership'
        },
        deleteMembership: {
            id: 'organizationAdmin.headers.deleteMembership'
        },
        createInvitation: {
            id: 'organizationAdmin.headers.createInvitation'
        },
        cancelInvitation: {
            id: 'organizationAdmin.headers.cancelInvitation'
        },
        resendInvitation: {
            id: 'organizationAdmin.headers.resendInvitation'
        },
        grantAdmin: {
            id: 'organizationAdmin.headers.grantAdmin'
        },
        revokeAdmin: {
            id: 'organizationAdmin.headers.revokeAdmin'
        },
        admin: {
            id: 'organizationAdmin.headers.admin'
        },
        nameAndEmail: {
            id: 'organizationAdmin.headers.nameAndEmail'
        },
        profile: {
            id: 'organizationAdmin.headers.profile'
        },
        waitForOrganizationApproval: {
            id: 'organizationAdmin.headers.waitForOrganizationApproval'
        }
    },
    buttons: {
        approveMembership: {
            id: 'organizationAdmin.buttons.approveMembership'
        },
        deleteMembership: {
            id: 'organizationAdmin.buttons.deleteMembership'
        },
        rejectMembership: {
            id: 'organizationAdmin.buttons.rejectMembership'
        },
        createInvitation: {
            id: 'organizationAdmin.buttons.createInvitation'
        },
        resendInvitation: {
            id: 'organizationAdmin.buttons.resendInvitation'
        },
        cancelInvitation: {
            id: 'organizationAdmin.buttons.cancelInvitation'
        },
        grantAdmin: {
            id: 'organizationAdmin.buttons.grantAdmin'
        },
        revokeAdmin: {
            id: 'organizationAdmin.buttons.revokeAdmin'
        }
    },
    labels: {
        isAdmin: {
            id: 'organizationAdmin.labels.isAdmin'
        }
    },
    infos: {
        activeOrganizationMembershipsEmptyLead: {
            id: 'organizationAdmin.infos.activeOrganizationMembershipsEmptyLead'
        },
        activeOrganizationMembershipsEmptyText: {
            id: 'organizationAdmin.infos.activeOrganizationMembershipsEmptyText'
        },
        invitationOrganizationMembershipsEmptyLead: {
            id: 'organizationAdmin.infos.invitationOrganizationMembershipsEmptyLead'
        },
        invitationOrganizationMembershipsEmptyText: {
            id: 'organizationAdmin.infos.invitationOrganizationMembershipsEmptyText'
        },
        pendingOrganizationMembershipsEmptyLead: {
            id: 'organizationAdmin.infos.pendingOrganizationMembershipsEmptyLead'
        },
        pendingOrganizationMembershipsEmptyText: {
            id: 'organizationAdmin.infos.pendingOrganizationMembershipsEmptyText'
        },
        waitForOrganizationApproval: {
            id: 'organizationAdmin.infos.waitForOrganizationApproval'
        }
    },
    intros: {
        approveMembership: {
            id: 'organizationAdmin.intros.approveMembership'
        },
        rejectMembership: {
            id: 'organizationAdmin.intros.rejectMembership'
        },
        deleteMembership: {
            id: 'organizationAdmin.intros.deleteMembership'
        },
        createInvitation: {
            id: 'organizationAdmin.intros.createInvitation'
        },
        cancelInvitation: {
            id: 'organizationAdmin.intros.cancelInvitation'
        },
        resendInvitation: {
            id: 'organizationAdmin.intros.resendInvitation'
        },
        grantAdmin: {
            id: 'organizationAdmin.intros.grantAdmin'
        },
        revokeAdmin: {
            id: 'organizationAdmin.intros.revokeAdmin'
        }
    },
    errors: {
        businessErrors: {
            InvitationAlreadyExists: {
                id: 'organizationAdmin.errors.businessErrors.InvitationAlreadyExists'
            },
            OrganizationMembershipAlreadyExist: {
                id: 'organizationAdmin.errors.businessErrors.OrganizationMembershipAlreadyExist'
            }
        }
    }
};
